"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotifications = exports.NotificationContext = exports.createMockNotifications = exports.NotificationContextProvider = void 0;
var create_notification_context_1 = require("./lib/create-notification-context");
var _a = (0, create_notification_context_1.createNotificationContext)(), NotificationContextProvider = _a.NotificationProvider, createMockNotifications = _a.createMockNotifications, useNotifications = _a.useNotifications, NotificationContext = _a.NotificationContext;
exports.NotificationContextProvider = NotificationContextProvider;
exports.createMockNotifications = createMockNotifications;
exports.useNotifications = useNotifications;
exports.NotificationContext = NotificationContext;
